// extracted by mini-css-extract-plugin
export default {"button":"trainingChallenges_button__eQf-a","tableActions":"trainingChallenges_tableActions__Ow0E5","tableActionsMD":"trainingChallenges_tableActionsMD__7zQYr"};